import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';

import { routes } from './app.routes';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './services/interceptors/auth-interceptor';
import { providePrimeNG } from 'primeng/config';
import { ConfirmationService } from 'primeng/api';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const EdgeTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#F2F4FA',
      100: '#E1E5F0',
      200: '#C3CBDF',
      300: '#97A4C7',
      400: '#6576AA',
      500: '#0F1738',
      600: '#0B112B',
      700: '#080D21',
      800: '#060A19',
      900: '#03050D',
      950: '#010207',
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: EdgeTheme,
        options: {
          darkModeSelector: '.dark',
        },
      },
    }),
    provideHttpClient(withInterceptors([authInterceptor])),
    ConfirmationService,
  ],
};
